import { NgModule, ModuleWithProviders } from '@angular/core';
import { CustomDescriptionComponent } from './custom-description.component';

@NgModule({
	declarations: [
		
		CustomDescriptionComponent
	],

	imports: [

		
	],
	entryComponents: [
		
	],
	providers: [
		
	],
	exports: [
		CustomDescriptionComponent
	],


})
export class CustomDescriptionModule {

}
